import {Grid, Paper, Typography} from "@mui/material"
import React, {useState, useEffect} from "react"
import AlertMessage from "src/components/alert-message"
import {IntegrationService} from "src/services/integration-service"
import {DataGrid} from "@mui/x-data-grid"
import SkeletonTable from "src/components/skeleton-table"

const DailyIntegrationReportPage = () => {
    const [loading, setLoading] = useState(false)
    const [alertMessageState, setAlertMessageState] = useState({open: false, message: "", type: ""})
    const [columns, setColumns] = useState([])
    const [tableData, setTableData] = useState([])

    const integrationService = new IntegrationService()

    const closeAlert = () => setAlertMessageState({...alertMessageState, open: false})
    const openAlert = (message, type) => setAlertMessageState({open: true, message, type})

    const carregarRelatorioTodasRotinas = () => {
        setLoading(true)
        setColumns([])
        setTableData([])

        integrationService.startarRelatorioTabelaDatalake()
            .then((response) => {
                try {
                    const jsonData = JSON.parse(response.text)
                    const rotinaData = jsonData.relatorio_rotina

                    if (!Array.isArray(rotinaData) || rotinaData.length === 0) {
                        openAlert("Nenhum dado disponível.", "info")
                        return
                    }

                    const generatedColumns = Object.keys(rotinaData[0]).map((key) => ({
                        field: key,
                        headerName: key,
                        width: 150
                    }))

                    const table = rotinaData.map((item, index) => ({
                        id: index,
                        ...item
                    }))

                    setColumns(generatedColumns)
                    setTableData(table)
                } catch (err) {
                    console.error("Erro ao processar resposta:", err)
                    openAlert("Erro ao processar resposta.", "error")
                } finally {
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.error("Erro ao buscar dados:", error)
                openAlert("Erro ao buscar dados.", "error")
                setLoading(false)
            })
    }

    useEffect(() => {
        carregarRelatorioTodasRotinas()
    }, [])

    return (
        <>
            <AlertMessage {...alertMessageState} close={closeAlert}/>

            <Grid container direction="row" justifyContent="space-between" spacing={2}>
                <Grid item>
                    <Typography variant="h5">Relatório Integrações Noturnas</Typography>
                </Grid>
            </Grid>
            <br/>
            <Paper>
                <Grid container>
                    <Grid item xs={12}>
                        {loading ? (
                            <SkeletonTable/>
                        ) : (
                            <div style={{height: 600, width: "100%"}}>

                                <DataGrid
                                    rows={tableData}
                                    columns={columns}
                                    getRowId={(row) => row.id}
                                    pageSize={5}
                                    rowsPerPageOptions={[5]}
                                    sx={{fontSize: '0.7rem'}}
                                />

                            </div>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default DailyIntegrationReportPage
